export { EditResourceLinkModal } from "./edit-resource-link-modal";
